import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { __decorate } from "tslib";
import { Vue, Component } from 'nuxt-property-decorator';

var Sidebar = /*#__PURE__*/function (_Vue) {
  _inherits(Sidebar, _Vue);

  var _super = _createSuper(Sidebar);

  function Sidebar() {
    var _this;

    _classCallCheck(this, Sidebar);

    _this = _super.apply(this, arguments);
    _this.firstname = '';
    _this.lastname = '';
    _this.email = '';
    return _this;
  }

  _createClass(Sidebar, [{
    key: "mounted",
    value: function mounted() {
      this.firstname = this.$store.$auth.user.data.firstname;
      this.lastname = this.$store.$auth.user.data.lastname;
      this.email = this.$store.$auth.user.data.email;
    }
  }]);

  return Sidebar;
}(Vue);

Sidebar = __decorate([Component({})], Sidebar);
export default Sidebar;